import _ from 'lodash';
import moment from 'moment';

const GeneralHelper = {
	isEmailValid(email) {
		const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return emailRegex.test(email);
	},
	isUstEmail(email) {
		if (!email || !GeneralHelper.isEmailValid(email)) {
			return false;
		}
		return _.endsWith(email, '@ust.hk') || _.endsWith(email, '.ust.hk') || _.endsWith(email, 'connect.ust.hk') || _.endsWith(email, '.connect.ust.hk');
	},
	isSlug(name) {
		const slugRegex = /^[a-z0-9]+(?:[-_][a-z0-9]+)*$/;
		return slugRegex.test(name);
	},
	// return true if all emails are hkust emails and there are at least 1 email
	validateUSTEmailsString(emailListString) {
		if (!emailListString) {
			return false;
		}
		const emails = _.compact(emailListString.split('\n').map(e => e.trim()));
		for (let i = 0; i < emails.length; i++) {
			if (!GeneralHelper.isUstEmail(emails[i])) {
				return false;
			}
		}
		return true;
	},
	queryStringToObject(queryString) {
		if (!queryString || !_.isString(queryString)) {
			return {};
		}
		if (queryString.indexOf('?') === 0) {
			queryString = queryString.substring(1);
		}
		try {
			return JSON.parse(
				'{"' +
				decodeURI(queryString)
					.replace(/"/g, '\\"')
					.replace(/&/g, '","')
					.replace(/=/g, '":"') +
				'"}'
			);
		} catch (e) { }
		return {};
	},
	getImageBasePath() {
		const path = process.env.NODE_ENV === 'development' ? '' : '/trns/app';
		return path;
	},
	checkIfSameValues(keys, dat) {
		const newArrObj = [];
		_.each(keys, field => {
			if (field.match(/date/g)) {
				const formatDate = moment(dat[field]).format('YYYY-MM-DD');
				newArrObj.push({ [field]: formatDate });
			} else {
				newArrObj.push({ [field]: typeof dat[field] === 'number' ? dat[field].toString() : dat[field] });
			}
		});
		return newArrObj;
	},
	areDateRangesOverlapping(start1, end1, start2, end2) {
		const range1 = moment.range(moment(start1, 'YYYY-MM-DD HH:mm'), moment(end1, 'YYYY-MM-DD HH:mm'));
		const range2 = moment.range(moment(start2, 'YYYY-MM-DD HH:mm'), moment(end2, 'YYYY-MM-DD HH:mm'));
		return range1.overlaps(range2, { adjacent: true });
	}
};

export default GeneralHelper;
